import { z } from 'zod';

const attribute = z.string().regex(/^[a-z][a-z0-9_]{0,62}$/);
export const ProcedureDataFilterSchema = z.object({
  field: attribute,
  operator: z.enum(['equals', 'not_equals', 'contains', 'greater', 'less', 'present', 'absent']),
  value: z.union([z.string().max(1000), z.number(), z.boolean()]).nullable().default(null),
});
export const ProcedureDataTriggerSchema = z.object({
  kind: z.enum(['periodic', 'condition', 'change', 'date']),
  source_type: attribute,
  active: z.boolean().default(true),
  include_existing: z.boolean().default(false),
  filters: z.array(ProcedureDataFilterSchema).max(20).default([]),
  date_field: attribute.nullable().default(null),
  days_before: z.number().int().min(0).max(366).default(0),
});
export type ProcedureDataTriggerInput = z.infer<typeof ProcedureDataTriggerSchema>;
export type ProcedureDataFilter = z.infer<typeof ProcedureDataFilterSchema>;
export interface ProcedureDataTriggerDto extends ProcedureDataTriggerInput {
  id: string;
  procedure_id: string;
  source_label: string;
  last_checked_at: string | null;
  last_error: string | null;
  opened: number;
}
export interface ProcedureDataTriggersState {
  rules: ProcedureDataTriggerDto[];
  types: Array<{ key: string; label: string; attributes: Array<{ name: string; label: string }> }>;
  /** La regola proposta dal «quando» della libreria, da confermare; null se il testo non si traduce senza indovinare. */
  suggestion: { kind: 'change' | 'date'; source_type: string; date_field: string | null; days_before: number | null; from: string } | null;
}
export interface ProcedureTriggerEvaluation { checked: number; opened: number; unverifiable: number; errors: string[] }
